import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//package import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Paper,
  Stack,
  Tabs,
  Tab,
  tabsClasses,
  CircularProgress,
  Backdrop,
  Alert,
  Tooltip,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { headersPost } from "../../../Services/API";
import { format } from "date-fns";
import { PROVINCE_API_ULRS } from "../../../Services/Routes/API";
import {
  RoutesUrls,
  pouRoutes,
  commonRoutes,
} from "../../../Services/Routes/APP";
import { DetailsIcon } from "../../../Svg";

//component

const Requests = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  // states
  const [page, setPage] = useState(1);
  const [requests, setRequests] = useState([]);
  const [searched, setSearched] = useState("");
  const [categorizedRequests, setCategorizedRequests] = useState([]);
  const [value, setValue] = React.useState("pending");
  const [totalCount, setTotalCount] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [api, setApi] = useState(false);
  const [alertIcon, setAlertIcon] = useState("error");
  const [loader, setLoader] = useState(false);
  const [propsData, setPropsData] = useState(state);
  const [searchData, setSearchData] = useState("");

  //variables
  const headings = [
    propsData?.type === "sent"
      ? "Receiver Name"
      : propsData?.type === "received" && "Sender",
    "Date",
    "Units Requested",
    "Actions",
  ];

  // life cycle

  useEffect(() => {
    if (state) {
      setPropsData(state);
    }
  }, [state]);

  useEffect(() => {
    setRequests([]);
    setCategorizedRequests([]);
    setTotalCount(0);

    getRequests();
  }, [propsData?.type]);

  useEffect(() => {
    setValue("pending");
    setRequests(categorizedRequests?.pending);
  }, [categorizedRequests]);

  const getRequests = () => {
    const data = {
      page: page,
      per_page: 5,
      type: propsData?.type,
    };
    setLoader(true);

    headersPost(PROVINCE_API_ULRS.GET_ALL_REQUESTS, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setCategorizedRequests(res?.data?.categorized_requests);
          setTotalCount(requests.length);
        } else {
          setRequests([]);
          setCategorizedRequests([]);
          setTotalCount(0);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
        setLoader(false);
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
        setLoader(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(true);
  };
  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const handleChange = (event, newValue) => {
    setRequests(categorizedRequests[newValue]);
    setValue(newValue);
  };

  const addHandler = (row) => {
    navigate(
      RoutesUrls?.pouAdmin + commonRoutes?.request + commonRoutes?.details,
      {
        state: {
          detailsType: "request",
          detailsData: row,
        },
      }
    );
  };

  const receiveHandler = (row) => {
    navigate(RoutesUrls.pouAdmin + pouRoutes.receiveInventory, {
      state: {
        request_data: row,
        type: propsData?.type,
      },
    });
  };

  // search
  const requestSearch = (searchedVal) => {
    const filteredRows = requests?.filter((row) => {
      let toCheckField = null;
      if (propsData?.type === "received") {
        toCheckField = row?.sender_name;
      } else if (propsData?.type === "sent") {
        toCheckField = row?.receiver_name;
      }
      return toCheckField?.toLowerCase()?.includes(searchedVal?.toLowerCase());
    });
    return filteredRows;
  };
  // render

  return (
    <Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          //   scrollButtons
          sx={{
            [`& .${tabsClasses.scrollButtons}`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
          }}
        >
          <Tab label="Pending" value="pending" />
          <Tab label="In Progress" value="in_progress" />
          <Tab label="Approved" value="approved" />
          <Tab label="Rejected" value="rejected" />
        </Tabs>
      </Box>

      <Paper
        sx={{
          p: 2,
          margin: "auto",
          borderRadius: 2,
        }}
      >
        <Box padding={2}>
          <Typography
            width={"100%"}
            variant="h5"
            fontWeight={"bold"}
            display={"flex"}
            justifyContent={"left"}
            color={"text.grayText"}
            sx={{
              textTransform: "uppercase",
              paddingBottom: 2,
            }}
          >
            {propsData?.type === "sent"
              ? "Requests Sent"
              : propsData?.type === "received" && "Requests Recieved"}
          </Typography>
          <Typography color={"text.grayText"}>Most Recent</Typography>

          <Box marginTop={2} display={"flex"} justifyContent={"flex-end"}>
            <TextField
              size="small"
              type="search"
              placeholder="Search by name"
              value={searched}
              onChange={(e) => {
                setSearched(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <SearchIcon
                    sx={{
                      color: theme.palette.primary.dark,
                    }}
                  />
                ),
              }}
              sx={{
                borderRadius: 25,
                backgroundColor: theme.palette.secondary.dark,
                ".MuiOutlinedInput-root": {
                  borderRadius: 25,
                  paddingX: 2,
                },
              }}
            ></TextField>
          </Box>
          <Box>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {headings?.map((h, index) => {
                      if (index < 3) {
                        return (
                          <TableCell
                            align="center"
                            key={`${index}-table-heading-${h}`}
                          >
                            <Chip
                              label={h}
                              sx={{
                                backgroundColor: `${theme.palette.secondary.dark}`,
                                borderRadius: 2,
                                color: "blue",
                              }}
                            ></Chip>
                          </TableCell>
                        );
                      }
                      if (index === 3) {
                        return (
                          <TableCell
                            align="center"
                            key={`${index}-table-heading-${h}`}
                          >
                            <Chip
                              label={h}
                              sx={{
                                color: "red",
                                backgroundColor: "#FFD8D8",
                                borderRadius: 2,
                              }}
                            ></Chip>
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {function () {
                    const filteredResult = requestSearch(searched);
                    return filteredResult?.length > 0 ? (
                      filteredResult?.map((row, index) => (
                        <TableRow key={`${index}-row.name-${index + 2}`}>
                          <TableCell align="center">
                            {propsData?.type === "sent"
                              ? row?.receiver_name
                              : propsData?.type === "received" &&
                                row?.sender_name}
                          </TableCell>
                          <TableCell align="center">
                            {row?.created_at
                              ? format(new Date(row?.created_at), "MM/dd/yyyy")
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.quantity}</TableCell>
                          <TableCell align="center">
                            <Stack
                              spacing={1}
                              direction={"row"}
                              justifyContent={"center"}
                            >
                              <Tooltip title="Details">
                                <Button
                                  color="secondary"
                                  variant="contained"
                                  onClick={() => addHandler(row)}
                                  sx={{
                                    borderRadius: 1,
                                    minWidth: 2,
                                    paddingX: 1,
                                  }}
                                >
                                  <DetailsIcon />
                                </Button>
                              </Tooltip>
                              {value === "in_progress" &&
                              propsData?.type === "sent" ? (
                                <Button
                                  color="primary"
                                  variant="contained"
                                  size="small"
                                  onClick={() => receiveHandler(row)}
                                  sx={{
                                    borderRadius: 2,
                                  }}
                                >
                                  Receive Inventory
                                </Button>
                              ) : null}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        {" "}
                        <TableCell colSpan={4}>
                          {" "}
                          <Typography
                            width={"100%"}
                            variant="body1"
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            {" "}
                            No Data Found
                          </Typography>{" "}
                        </TableCell>{" "}
                      </TableRow>
                    );
                  }.call()}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Requests;
